export const MONTH_LIST = [
    { key: "t1",  label: "Tháng 1"  },
    { key: "t2",  label: "Tháng 2"  },
    { key: "t3",  label: "Tháng 3"  },
    { key: "t4",  label: "Tháng 4"  },
    { key: "t5",  label: "Tháng 5"  },
    { key: "t6",  label: "Tháng 6"  },
    { key: "t7",  label: "Tháng 7"  },
    { key: "t8",  label: "Tháng 8"  },
    { key: "t9",  label: "Tháng 9"  },
    { key: "t10", label: "Tháng 10" },
    { key: "t11", label: "Tháng 11" },
    { key: "t12", label: "Tháng 12" },
];

export const DEFAULT_UNITS = [
    "Buổi",
    "Buổi học",
    "Bữa ăn",
    "Cái",
    "Chiếc",
    "Chuyến",
    "Đợt",
    "Học kỳ",
    "Khóa",
    "Lần",
    "Ngày",
    "Suất",
    "Tháng"
];

// ─── Loại điểm danh ────────────────────────────────────────────
// IN + BEFORE
export const ATTEND_TYPE_IN_BEFORE = [
    { key: "LEARN", value: "Điểm danh đi học" },
    { key: "EAT",   value: "Điểm danh ăn" },
];
// IN + AFTER
export const ATTEND_TYPE_IN_AFTER = [
    { key: "LEARN", value: "Điểm danh đi học" },
    { key: "LATE",  value: "Đón muộn" },
];
// OUT + AFTER
export const ATTEND_TYPE_OUT_AFTER = [
    { key: "LEARN", value: "Điểm danh đi học" },
    { key: "EAT",   value: "Điểm danh ăn" },
];

// ─── Chi tiết (configKey) ───────────────────────────────────────
export const CONFIG_KEY_IN_BEFORE_LEARN = [
    { key: "SCHEDULE", value: "Thu tiền học theo lịch" },
    { key: "MON_FRI",  value: "Thu tiền từ thứ 2 đến thứ 6" },
    { key: "MON_SAT",  value: "Thu tiền từ thứ 2 đến thứ 7" },
    { key: "SAT_ONLY", value: "Chỉ thu thứ 7" },
];
export const CONFIG_KEY_IN_BEFORE_EAT = [
    { key: "BREAKFAST", value: "Thu bữa sáng" },
    { key: "MAIN_MEAL", value: "Thu bữa chính" },
    { key: "SNACK",     value: "Thu bữa phụ" },
    { key: "DINNER",    value: "Thu bữa tối" },
];
export const CONFIG_KEY_IN_AFTER_LEARN = [
    { key: "SAT_CURRENT",     value: "Chỉ thu thứ 7 (Tháng hiện tại)" },
    { key: "SUN_CURRENT",     value: "Chỉ thu CN (Tháng hiện tại)" },
    { key: "SAT_SUN_CURRENT", value: "Thu thứ 7 + CN (Tháng hiện tại)" },
    { key: "SAT_PREV",        value: "Chỉ thu thứ 7 (Tháng trước)" },
    { key: "SUN_PREV",        value: "Chỉ thu CN (Tháng trước)" },
    { key: "SAT_SUN_PREV",    value: "Thu thứ 7 + CN (Tháng trước)" },
];
export const CONFIG_KEY_OUT_AFTER_LEARN = [
    { key: "ABSENT_YES",            value: "Trả lại tiền nghỉ có phép" },
    { key: "ABSENT_NO",             value: "Trả lại tiền nghỉ không phép" },
    { key: "ABSENT_YES_NO_MON_SAT", value: "Trả lại tiền nghỉ T.2-T7(Có P+Ko P)" },
    { key: "ABSENT_YES_MON_SAT",    value: "Trả lại tiền nghỉ T.2-T7(Có P)" },
    { key: "ABSENT_YES_MON_FRI",    value: "Trả lại tiền nghỉ T.2-T.6(Có P)" },
    { key: "ABSENT_YES_NO_MON_FRI", value: "Trả lại tiền nghỉ T.2-T.6(Có P+Ko P)" },
    { key: "ABSENT_YES_SAT",        value: "Trả lại tiền nghỉ T.7(Có P)" },
    { key: "ABSENT_YES_NO_SAT",     value: "Trả lại tiền nghỉ T.7(Có P+Ko P)" },
    { key: "ABSENT_YES_NO_SUN",     value: "Trả lại tiền học CN (Có P + Ko P)" },
    { key: "ABSENT_YES_SUN",        value: "Trả lại tiền học CN (Có P)" },
];
export const CONFIG_KEY_OUT_AFTER_EAT = [
    { key: "REFUND_BREAKFAST", value: "Hoàn tiền ăn bữa sáng" },
    { key: "REFUND_MAIN_MEAL", value: "Hoàn tiền ăn bữa chính" },
    { key: "REFUND_SNACK",     value: "Hoàn tiền ăn bữa phụ" },
    { key: "REFUND_DINNER",    value: "Hoàn tiền ăn bữa tối" },
    { key: "REFUND_ALL_DAY",   value: "Hoàn tiền ăn một ngày" },
];